export const normalizeListResponse = (payload, { skip = 0, limit = 0 } = {}) => {
  if (Array.isArray(payload)) {
    const hasNextPage = limit > 0 && payload.length === limit;
    return {
      data: payload,
      count: skip + payload.length + (hasNextPage ? 1 : 0)
    };
  }

  const data = Array.isArray(payload?.data) ? payload.data : [];
  const count = Number.isFinite(payload?.generalRecordsCount)
    ? payload.generalRecordsCount
    : data.length;

  return { data, count };
};
